import React from 'react';
import './Banner.css';

const Banner = (props) => {
    return (
        <div className="banner">
            <div className="main-part">
                <img src={props.src} alt="img" className="banner-img" />
                <h3 className="head">{props.head}</h3>
            </div>
            <h5 className="content">{props.content}</h5>
        </div>
    )
}

export default Banner;